import PropTypes from "prop-types";
import { useState, useEffect, useContext, useRef, useCallback } from "react";
// next
import { useRouter } from "next/router";
// hooks
import useAuth from "src/hooks/useAuth";
// components
import LoadingScreen from "src/components/LoadingScreen";
import Invited_Journey from "src/modules/invite-section/Invited_Journey";
import RecommendScreenSizePopup from "src/components/RecommendScreenSizePopup";
import { TrackWebappEvent } from "../modules/segment-event-tracking/segmentEventTracking";
import { EventTrackName } from "../modules/segment-event-tracking/constant";
import { get } from "lodash";
import { getTemplate } from "@/modules/editor-v2/services/MyWorks";
import { useSetAtom, useAtomValue } from "jotai";
import { activeProjectAtom, initializingEditorAtom, shouldResizeAtom, standardInfographic, toAddBackgroundAtom, toAddBackgroundIdAtom } from "@/modules/editor-v2/Atoms";
import { DEFAULT_SIZES } from "@/modules/editor-v2/LeftToolBar/Resize/DefaultSizes";
import useToast from "@/hooks/useToast";
import { createEmptyEditorJob, getCategories, getJobDetails } from "@/modules/editor-v2/services/Jobs";
import { dispatch, useSelector } from 'src/redux/store';
import { applyCouponCode } from 'src/services/apply-coupon';
import { setCouponData } from 'src/redux/reducers/appRedirect.reducer';
// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

function classifyImageFormat(format = "SQUARE") {
  return format?.toUpperCase() === "SQUARE" ? '1/1' : format?.toUpperCase() === "PORTRAIT" ? '9/16' : '16/9';
}

function extractJobNumber(url) {
  var regex = /\/([a-zA-Z0-9]+)\?/;
  var match = url.match(regex);
  if (match && match.length > 1) {
      return match[1];
  } else {
      return null;
  }
};


export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, user, login, logout, magicQrLogin } = useAuth();

  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const toaster = useToast();
  const [magicLoginLoading, setMagicLoginLoading] = useState(false);
  const { query } = useRouter();
  const setIsEditorInitializing = useSetAtom(initializingEditorAtom);
  const setActiveProject = useSetAtom(activeProjectAtom);
  const setToAddBackgroundId = useSetAtom(toAddBackgroundIdAtom);
  const setToAddBackground = useSetAtom(toAddBackgroundAtom);
  const setShouldResize= useSetAtom(shouldResizeAtom);
  const isStandardInfographic = useAtomValue(standardInfographic);
  const {couponData} = useSelector(state=>state.appRedirect);

  function getCurrentDimension(){
    return {
      width:window.innerWidth,
      height:window.innerHeight
    }
  };




useEffect(()=>{
  const screenSizeHandler=()=>{
    setScreenSize(getCurrentDimension());
  }

  window.addEventListener('resize',screenSizeHandler);

  return ()=>{
    window.removeEventListener('resize',screenSizeHandler);
  }
},[screenSize])

useEffect(() => {
  if (user?.entity?.entity?._id && localStorage.getItem('triggerMailEvent')) {
    const eventPayload = {
      login_mode: get(user, ["user", "login_type"], ""),
      identifier: get(user, ["user", "email"], ""),
      userId: get(user, ["user", "_id"], ""),
      platform: "Webapp",
      region: get(user, ["entity", "entity", "country"], ""),
      language: get(user, ["user", "language"], ""),
      couponCode: get(user, ["user", "countryCode"], ""),
      email: get(user, ["user", "email"], ""),
      mobile: get(user, ["user", "phone"], ""),
      entity_id: get(user, ["entity", "entity", "_id"], ""),
    };
    const jobNumber = extractJobNumber(window.location.href);
    if(jobNumber)eventPayload.job_id = jobNumber
    TrackWebappEvent(
      `${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._click_view_deliver_mail}`, eventPayload);
    localStorage.setItem('triggerMailEvent',false);
    localStorage.removeItem('triggerMailEvent');
  }
  console.log("here izz",couponData )
  if(user?.entity?.entity?._id && user?.user?.login_type !== "Guest"  && couponData?.couponCode){
    const couponCode=couponData?.couponCode ?? "";
    const entityId=user?.entity?.entity?._id ?? "";

    applyCoupon(couponCode,entityId);
    dispatch(setCouponData({}));
  }

}, [get(user, ["user", "_id"], ""),localStorage.getItem('triggerMailEvent')]); 

const createTemplateJob = async(template_id) => {
  if(!template_id)return;
  const response = await getTemplate(template_id);
  if(!response?._id)return;
  setLoading(true);
  setActiveProject(undefined);
  try{
    setIsEditorInitializing(true);
    setToAddBackgroundId(response?._id);
    setToAddBackground(response?.editorThumbnail);
    const aspectRatio = classifyImageFormat(response?.supported_formats)
    const backgroundSize = DEFAULT_SIZES.find(obj=>obj?.aspectRatio === aspectRatio);
    setShouldResize({height:backgroundSize?.height,width:backgroundSize?.width})
    const categories = await getCategories();
    const otherCategory = categories?.find(cat => 
      cat.name?.toLowerCase()?.includes('other'),
    );
    const otherSubCategory = otherCategory?.subcategories?.find(subCat =>
      subCat?.name?.toLowerCase()?.includes('other'),
    );
    if(!otherCategory?._id || !otherSubCategory?._id) throw new Error(`Invalid category_id or subcategory_id`);
    const jobData = await createEmptyEditorJob(otherCategory?._id, otherSubCategory?._id, isStandardInfographic);
    const jobId = jobData?.job_id;
    const job = await getJobDetails(jobId);
    setActiveProject(job);
  }catch(err){
    setLoading(false);
      setIsEditorInitializing(false);
      setToAddBackgroundId("");
      setToAddBackground("");
      toaster.error("Something went wrong while adding template to canvas");
      console.log(err)
  }
};
const templateOnCanvasHandler = async() => {
  const branchData = JSON.parse(JSON.stringify(localStorage.getItem('branchData')));
  const templateId = sessionStorage.getItem('selected_template_id');
  if(user?.entity?.entity?._id && templateId && !localStorage.getItem('magicQrInfo')){
    await createTemplateJob(templateId);
    sessionStorage.removeItem('selected_template_id');
  }
  if(!branchData || !branchData?.template_id || !user?.entity?.entity?._id)return;
  await createTemplateJob(branchData?.template_id);
  localStorage.removeItem('branchData');
}

useEffect(()=>{templateOnCanvasHandler()},[user,loading]);

  if (!isInitialized || JSON.parse(localStorage.getItem('magicQrInfo'))) {     
    return <LoadingScreen />;
  }

  // if (!isAuthenticated || user?.user?.login_type === "Guest") {
  //   return (
  //   <>
  //     <RecommendScreenSizePopup screenSize={screenSize} open={open} setOpen={setOpen} />
  //     <EditorPage />
  //   </>
  //   );
  // }

  const applyCoupon=async(couponCode,entityId)=>{
      try{
          await applyCouponCode(couponCode,entityId);
      }catch(error){
          console.error("Error",error);
      }
   };

  return (
    <>
    <RecommendScreenSizePopup screenSize={screenSize} open={open} setOpen={setOpen} />
    <Invited_Journey/>
    {children}
    </>
  );
}
